import * as z from 'zod';
import client from '../client';

import { SEO, Localization } from '../strapiSchema';
import { blocksSchema } from '../blocksSchema';
import { blocks, seo, localizations } from '../strapiBlocks';
import { isNotFoundError, logMissingResource, PRIMARY_LOCALE } from '../strapiLocale';

const HomePage = z.object({
  id: z.number(),
  documentId: z.string(),
  blocks: z.array(blocksSchema),
  seo: SEO,
  localizations: z.array(Localization),
  locale: z.string(),
});

export type HomePageType = z.infer<typeof HomePage>;

export const getHomePage = async (
  locale: string = PRIMARY_LOCALE,
): Promise<HomePageType | null> => {
  try {
    const response = await client.get('/api/home-page', {
      params: {
        locale,
        populate: {
          blocks,
          seo,
          localizations,
        },
      },
    });

    if (!response.data?.data) {
      if (locale !== PRIMARY_LOCALE) {
        logMissingResource('home-page', locale);
        return null;
      }
      throw new Error('No home page found');
    }

    return HomePage.parseAsync(response.data.data);
  } catch (error) {
    if (locale !== PRIMARY_LOCALE && isNotFoundError(error)) {
      logMissingResource('home-page', locale);
      return null;
    }

    const errorMessage = error instanceof Error ? error.message : 'Unknown error';
    throw new Error(`API response do not match Home Page structure : ${errorMessage}`);
  }
};
